export default {
  anonymousUser: {
    id: 'reviews_anonymous_customer',
    defaultMessage: 'An anonymous Backer',
  },
  verified: {
    id: 'product_review_display_verified',
    defaultMessage: 'Verified',
  },
  verifiedPurchase: {
    id: 'product_review_display_verified_purchase',
    defaultMessage: 'Verified purchase',
  },
  reviewInfo: {
    id: 'product_review_display_review_info',
    defaultMessage: 'Reviewed {reviewDate}, {country}',
  },
} as const
